import React from 'react';

// Components
import { Button } from '@/views/components/buttons';
import { CloseButton } from '@/views/components/buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';

type Props = {
  title: string;
  onExit: () => void;
  onBack?: () => void;
};

const ProposalEditorOptionsHeader = (props: Props) => {
  const { title, onBack, onExit } = props;

  return (
    <Modal.Header className="secondary-header proposal-editor-options-header">
      {onBack && <Button className="back-button" icon="arrow-left" onClick={onBack} aria-label={formatMessage('Common.BackToPreviousPage')} />}
      <Modal.Title className="proposal-editor-options-header-title">
        <FormattedMessage id={title} />
      </Modal.Title>
      <CloseButton onClick={onExit} />
    </Modal.Header>
  );
};

export default ProposalEditorOptionsHeader;
